import { Category } from '@/apis/providers/types/provider.types'
import { Card, CardContent, CardHeader } from '@/app/common/components/Card'
import Checkbox from '@/app/common/components/Checkbox'
import FormErrorMessage from '@/app/common/components/FormErrorMessage'
import { Label } from '@/shad/ui/label'
import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export interface Expense {
  id: number
  name: string
}

interface ExpenseCategoriesSelectionProps {
  expenses: Expense[]
  control: Control<any>
  error?: string | undefined
  handleCheckboxChange: (expense: number, checked: boolean) => void
  selectedCategories: Category[]
}

export function ExpenseCategoriesSelection({
  expenses,
  control,
  selectedCategories,
  error,
  handleCheckboxChange,
}: ExpenseCategoriesSelectionProps) {
  const { t } = useTranslation()

  console.log("Expenses", expenses)
  console.log("error", error)

  return (
    <Card className="w-full">
      <CardHeader>
        <h3 className="text-lg block font-medium text-gray-800 tracking-tight">
          {t('select_expense_categories')}
        </h3>
      </CardHeader>
      <CardContent className="w-full">
        <Controller
          name="expenseCategories"
          control={control}
          render={() => (
            <>
              {expenses.map((expense) => (
                <div key={expense.name} className="mb-4 flex items-center">
                  <div className="flex items-center">
                    <Checkbox
                      name={expense.name}
                      id={`expense-${expense.id}`}
                      checked={selectedCategories.some(
                        (item) => item.id === expense.id
                      )}
                      onChange={(checked) => {
                        handleCheckboxChange(expense.id, checked)
                      }}
                    />
                    <Label
                      htmlFor={`expense-${expense.id}`}
                      className="ml-2 cursor-pointer"
                      onClick={() => {
                        const newCheckedState = !selectedCategories.some(
                          (item) => item.id === expense.id
                        )
                        handleCheckboxChange(expense.id, newCheckedState)
                      }}
                    >
                      {t(`categories.${expense.name.trim()}`, expense.name)}
                    </Label>
                  </div>
                </div>
              ))}
            </>
          )}
        />
        {error && (
          <FormErrorMessage message={t(`${error}`)} className="text-red-500 mt-2" />
        )}
      </CardContent>
    </Card>
  )
}